import { z } from "zod";

export const RECENTLY_VIEWED_LIMIT = 20;

export const savedListingInputSchema = z
    .object({
        listingId: z.string().min(1),
    })
    .strict();

export const savedListingMutationResultSchema = z
    .object({
        listingId: z.string().min(1),
        isFavorited: z.boolean(),
    })
    .strict();

export const savedListingReferenceSchema = z
    .object({
        listingId: z.string().min(1),
        savedAt: z.date(),
    })
    .strict();

export const savedListingReferencesSchema = z.array(
    savedListingReferenceSchema,
);

export const recordListingViewInputSchema = z
    .object({
        listingId: z.string().min(1),
        source: z.string().min(1).optional(),
    })
    .strict();

export const recentlyViewedListingReferenceSchema = z
    .object({
        listingId: z.string().min(1),
        viewedAt: z.date(),
    })
    .strict();

export const recentlyViewedListingReferencesSchema = z.array(
    recentlyViewedListingReferenceSchema,
);

export const favoriteMutationVariablesSchema = z
    .object({
        listingId: z.string().min(1),
        nextFavorited: z.boolean(),
        isSignedIn: z.boolean(),
    })
    .strict();

export type SavedListingInput = z.input<typeof savedListingInputSchema>;
export type SavedListingReference = z.output<
    typeof savedListingReferenceSchema
>;
export type RecordListingViewInput = z.input<
    typeof recordListingViewInputSchema
>;
export type FavoriteMutationVariables = z.output<
    typeof favoriteMutationVariablesSchema
>;
